import { ConfigReportComboApi } from "go-report-combo/User/services/types";

export const REPORT_management_source = {
	id: "REPORT_management_source",
	name: "Sales location source",
	data: [
		{
			id: "TRANSACTION",
			resource: "TRANSACTION",
			filter: "status|e=PAYMENT_DUE¥PAID",
			groups: ["NONE", "COMPANY_SOURCE"],
			columns: [
				{
					id: "summary",
					filter: "date|bt=previous_2-2_months",
				},
			],
		},
		{
			id: "TRANSACTION_LAST_MONTH",
			resource: "TRANSACTION",
			filter: "status|e=PAYMENT_DUE¥PAID",
			groups: ["NONE", "COMPANY_SOURCE"],
			columns: [
				{
					id: "summary",
					filter: "date|bt=previous_3-3_months",
				},
			],
		},
		{
			id: "TRANSACTION_LAST_YEAR",
			resource: "TRANSACTION",
			filter: "status|e=PAYMENT_DUE¥PAID",
			groups: ["NONE", "COMPANY_SOURCE"],
			columns: [
				{
					id: "summary",
					filter: "date|bt=previous_13-13_months",
				},
			],
		},
	],
	rows: [
		{
			id: "SUMMARY_organization",
			name: "Lokalizacje",
			type: "CALCULATE",
			aggregate: "TRANSACTION.quantity_customer",
			group: "COMPANY_SOURCE",
			aggregate_columns: {
				current_location: "TRANSACTION.quantity_customer",
				last_month_location: "TRANSACTION_LAST_MONTH.quantity_customer",
				last_month_location_growth:
					"((TRANSACTION.quantity_customer - TRANSACTION_LAST_MONTH.quantity_customer) / TRANSACTION_LAST_MONTH.quantity_customer) * 100",
				last_year_location: "TRANSACTION_LAST_YEAR.quantity_customer",
				last_year_location_growth:
					"((TRANSACTION.quantity_customer - TRANSACTION_LAST_YEAR.quantity_customer) / TRANSACTION_LAST_YEAR.quantity_customer) * 100",
			},
		},
		{
			id: "DIVIDER",
			name: "DIVIDER",
			type: "DIVIDER",
		},
		{
			id: "SUMMARY_organization_mrr",
			name: "MRR",
			type: "CALCULATE",
			aggregate: "TRANSACTION.total_price",
			group: "COMPANY_SOURCE",
			aggregate_columns: {
				current_location: "TRANSACTION.total_price",
				last_month_location: "TRANSACTION_LAST_MONTH.total_price",
				last_month_location_growth:
					"((TRANSACTION.total_price - TRANSACTION_LAST_MONTH.total_price) / TRANSACTION_LAST_MONTH.total_price) * 100",
				last_year_location: "TRANSACTION_LAST_YEAR.total_price",
				last_year_location_growth:
					"((TRANSACTION.total_price - TRANSACTION_LAST_YEAR.total_price) / TRANSACTION_LAST_YEAR.total_price) * 100",
			},
		},
		{
			id: "SUMMARY_organization_product",
			name: "Produkty",
			type: "CALCULATE",
			aggregate: "TRANSACTION.solution_quantity",
			group: "COMPANY_SOURCE",
			aggregate_columns: {
				current_location: "TRANSACTION.solution_quantity",
				last_month_location: "TRANSACTION_LAST_MONTH.solution_quantity",
				last_month_location_growth:
					"((TRANSACTION.solution_quantity - TRANSACTION_LAST_MONTH.solution_quantity) / TRANSACTION_LAST_MONTH.solution_quantity) * 100",
				last_year_location: "TRANSACTION_LAST_YEAR.solution_quantity",
				last_year_location_growth:
					"((TRANSACTION.solution_quantity - TRANSACTION_LAST_YEAR.solution_quantity) / TRANSACTION_LAST_YEAR.solution_quantity) * 100",
			},
		},
		{
			id: "SUMMARY_organization_product_avg",
			name: "Produkty średnia",
			type: "CALCULATE",
			aggregate: "TRANSACTION.solution_quantity",
			group: "COMPANY_SOURCE",
			aggregate_columns: {
				current_location: "(TRANSACTION.solution_quantity / TRANSACTION.quantity_customer)",
				last_month_location:
					"TRANSACTION_LAST_MONTH.solution_quantity / TRANSACTION_LAST_MONTH.quantity_customer",
				last_month_location_growth:
					"(((TRANSACTION.solution_quantity / TRANSACTION.quantity_customer) - (TRANSACTION_LAST_MONTH.solution_quantity / TRANSACTION_LAST_MONTH.quantity_customer)) / (TRANSACTION_LAST_MONTH.solution_quantity / TRANSACTION_LAST_MONTH.quantity_customer)) * 100",
				last_year_location: "TRANSACTION_LAST_YEAR.solution_quantity / TRANSACTION_LAST_YEAR.quantity_customer",
				last_year_location_growth:
					"(((TRANSACTION.solution_quantity / TRANSACTION.quantity_customer) - (TRANSACTION_LAST_YEAR.solution_quantity / TRANSACTION_LAST_YEAR.quantity_customer)) / (TRANSACTION_LAST_YEAR.solution_quantity / TRANSACTION_LAST_YEAR.quantity_customer)) * 100",
			},
		},
	],
	columns: [
		{
			id: "current_location",
			data_column_id: "summary",
			name: "Ilość",
		},
		{
			id: "last_month_location",
			data_column_id: "summary",
			name: "Poprzedni miesiąc",
		},
		{
			id: "last_month_location_growth",
			data_column_id: "summary",
			name: "Wzrost %",
			format: "PERCENT",
		},
		{
			id: "last_year_location",
			data_column_id: "summary",
			name: "Poprzedni rok",
		},
		{
			id: "last_year_location_growth",
			data_column_id: "summary",
			name: "Wzrost %",
			format: "PERCENT",
		},
	],
} as ConfigReportComboApi;
